var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-down-line_svg__clip0_4001_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.987 7.157L7.31 9.835a.678.678 0 10.959.958l3.834-3.834a.678.678 0 000-.959L8.269 2.166a.678.678 0 00-.959.958l2.677 2.678H1.011a.678.678 0 000 1.355h8.976z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-down-line_svg__clip0_4001_84"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 6.167 5.833)",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgArrowDownLine;